{
  "common": {
    "cancel": "Annuler",
    "create": "Créer",
    "creating": "Création…",
    "retry": "Réessayer",
    "readOnlyBanner": "Cet espace de test est en lecture seule. Tout reste consultable — les exécutions passées, leurs résultats et l'ensemble de la configuration — mais les nouveaux travaux et les modifications sont désactivés.",
    "readOnlyReason": "Cet espace de test est en lecture seule ; cet élément ne peut pas être modifié.",
    "noWriteBanner": "Vous pouvez tout consulter dans cet espace de test — données, cas, exécutions passées et résultats — mais les modifications, les téléversements et les exécutions nécessitent l’autorisation Collaborateur sur ce modèle. Le propriétaire du modèle ou un administrateur peut l’accorder.",
    "noWriteReason": "Modifier cet espace de test nécessite l’autorisation Collaborateur sur ce modèle.",
    "stillWorking": "Toujours en cours…"
  },
  "home": {
    "title": "Banc d'essai",
    "subtitle": "Concevez et exécutez des pipelines de test sur vos données.",
    "workspacesHeading": "Espaces de test",
    "newWorkspace": "Nouvel espace",
    "empty": "Aucun espace de test pour l'instant.",
    "createFirst": "Créer votre premier espace",
    "cardMetaTables_one": "{{count}} table",
    "cardMetaTables_other": "{{count}} tables",
    "cardMetaCases_one": "{{count}} cas de test",
    "cardMetaCases_other": "{{count}} cas de test",
    "open": "Ouvrir",
    "delete": "Supprimer",
    "deleteTitle": "Supprimer l'espace ?",
    "deleteBody": "Ceci supprime définitivement « {{name}} » ainsi que toutes ses données, cas de test et exécutions.",
    "backToList": "Retour aux espaces",
    "nameLabel": "Nom de l'espace",
    "namePlaceholder": "p. ex. Validation PD annuelle",
    "scopeLabel": "Domaine",
    "scopeChange": "Modifier",
    "scopeGenericNotAllowed": "La tâche générique ne peut pas être utilisée pour un espace de test — choisissez un domaine dans le menu.",
    "scopeHint": "Le domaine méthodologique de cet espace. Il ne peut pas être modifié après la création.",
    "outputLanguage": "Langue des réponses"
  },
  "rail": {
    "data": "Données",
    "dataCount": "{{confirmed}}/{{total}} confirmées",
    "testCases": "Cas de test",
    "newCase": "Nouveau cas de test",
    "confirmFirst": "Confirmez au moins une table pour ajouter un cas de test.",
    "noCases": "Aucun cas de test pour l'instant.",
    "caseNameLabel": "Nom du cas de test",
    "caseNamePlaceholder": "p. ex. Exécution de référence",
    "pickCase": "Sélectionnez un cas de test pour continuer."
  },
  "case": {
    "saveWebhook": "Enregistrer",
    "savingWebhook": "Enregistrement…",
    "webhookHint": "Les exécutions que vous lancerez à partir de maintenant enverront leur résultat à cette adresse https à la fin. Laissez le champ vide pour n'envoyer aucune notification.",
    "webhookLabel": "URL du webhook",
    "webhookPlaceholder": "https://exemple.com/hooks/reggie"
  },
  "stage": {
    "data": {
      "tab": "Données"
    },
    "discover": {
      "tab": "Découverte"
    },
    "build": {
      "tab": "Conception"
    },
    "run": {
      "tab": "Exécution"
    }
  },
  "discover": {
    "openingTitle": "Que cherchons-nous à faire aujourd'hui ?",
    "openingSubtitle": "Décrivez votre objectif. Je récupérerai la bonne méthodologie et les bonnes fonctions, puis je proposerai un pipeline à partir de vos données confirmées.",
    "composerPlaceholder": "Décrivez ce que vous voulez tester…",
    "composerBusy": "En attente de la réponse en cours…",
    "composerBusyHint": "Un message à la fois — en attente de la fin de la réponse de l'assistant.",
    "send": "Envoyer",
    "thinking": "Traitement…",
    "cancel": "Arrêter",
    "turnFailed": "L'assistant n'a pas pu terminer. Veuillez réessayer.",
    "failure": {
      "agent_max_rounds": "L'assistant a atteint sa limite d'étapes avant de terminer. Essayez une demande plus ciblée.",
      "agent_timeout": "L'assistant a mis trop de temps à répondre. Veuillez réessayer.",
      "agent_refused": "L'assistant a refusé cette demande. Essayez de la reformuler.",
      "llm_infrastructure": "L'assistant est temporairement indisponible. Veuillez réessayer dans quelques instants.",
      "tool_failed": "L'assistant n'a pas pu accéder aux données nécessaires. Veuillez réessayer.",
      "tool_result_shape_invalid": "L'assistant a reçu des données illisibles. Veuillez réessayer ; si le problème persiste, contactez le support.",
      "discovery_empty_answer": "L'assistant n'a produit aucune réponse. Veuillez réessayer.",
      "discovery_incomplete": "La réponse de l'assistant a été interrompue. Veuillez réessayer.",
      "config_generation_failed": "Le pipeline a été enregistré, mais ses paramètres n'ont pas pu être renseignés. Réessayez pour les compléter.",
      "config_incomplete": "Le pipeline a été enregistré, mais ses paramètres n'ont été que partiellement renseignés. Réessayez pour les compléter.",
      "config_draft_missing": "Décrivez d'abord un pipeline ; ses paramètres pourront ensuite être renseignés.",
      "node_already_resolved": "Ce bloc a déjà du code. Choisissez « Régénérer le code » pour le remplacer."
    },
    "turnCancelled": "Arrêté.",
    "noAnswer": "Aucune réponse n'a été produite.",
    "activityLines_other": "{{count}} étapes de récupération",
    "activityLines_one": "{{count}} étape de récupération",
    "proposalTitle": "Proposition de pipeline",
    "proposalViewInBuild": "Voir dans Construire",
    "attachTooltip": "Joindre un document d'appui",
    "attachedChip": "📎 {{filename}}",
    "extracting": "Lecture du document…",
    "enqueued": "Message envoyé. En attente de l'assistant…",
    "micStart": "Démarrer la saisie vocale",
    "micStop": "Terminer la saisie vocale",
    "micCancel": "Annuler la saisie vocale",
    "micRequestingPermission": "Autorisez l’accès au microphone…",
    "micListening": "À l’écoute…",
    "micSpeechDetected": "À l’écoute de votre message…",
    "micTranscribing": "Transcription en cours…",
    "micDone": "Message vocal envoyé",
    "micLevel": "Niveau du microphone",
    "micUnsupported": "Ce navigateur ne prend pas en charge la saisie vocale."
  },
  "build": {
    "emptyTitle": "Aucun pipeline pour l'instant",
    "emptySubtitle": "Concevez un pipeline dans le chat Découverte — dès que l'assistant en propose un, il apparaît ici pour révision et ajustement.",
    "unboundInput": "Entrée non liée",
    "placeholder": "code requis",
    "portArgs": "entrées",
    "packageMembers": "sorties",
    "kind": {
      "input": "Entrée de données",
      "bf": "Fonction",
      "custom": "Nœud personnalisé"
    },
    "validationHeading": "Validation",
    "issueGoToNode": "{{issue}} — ouvrir ce bloc",
    "issueGoToEdge": "{{issue}} — ouvrir cette connexion",
    "issuePipelineLevelHeading": "Pipeline entier",
    "valid": "Valide",
    "invalid_other": "{{count}} problèmes",
    "validHint": "Ce pipeline est valide et prêt à être exécuté.",
    "paletteHeading": "Ajouter",
    "addCustomNode": "Nœud personnalisé",
    "paletteHint": "Les fonctions de base sont ajoutées par l'assistant dans le chat Découverte.",
    "lockedBanner": "L'assistant met à jour ce pipeline. La modification est suspendue jusqu'à la fin.",
    "invalid_one": "{{count}} problème",
    "paletteFunctions": "Fonctions",
    "paletteSearch": "Rechercher des fonctions…",
    "paletteNoMatch": "Aucune fonction ne correspond à votre recherche.",
    "paletteScopeEmpty": "Ce périmètre n’a aucune étape prête à l’emploi. Le nœud personnalisé fonctionne toujours — ajoutez-en un pour créer votre propre étape.",
    "paletteReadyCount_one": "{{count}} étape prête à l’emploi est disponible pour ce périmètre.",
    "paletteReadyCount_other": "{{count}} étapes prêtes à l’emploi sont disponibles pour ce périmètre.",
    "addFunction": "Ajouter au pipeline",
    "autoArrange": "Organiser automatiquement",
    "paletteDragHint": "Glissez une fonction sur le canevas.",
    "dockedChatTitle": "Assistant",
    "expandChat": "Afficher l'assistant",
    "collapseChat": "Masquer l'assistant",
    "resizeChat": "Redimensionner le panneau de l'assistant",
    "heldInvalidBanner": "Cette modification n'est pas encore enregistrée — résolvez les problèmes signalés pour l'enregistrer.",
    "invalidDraftBanner": "Ce pipeline enregistré comporte des problèmes non résolus — corrigez-les avant de pouvoir l'exécuter.",
    "paletteUncategorized": "Autres",
    "editor": {
      "close": "Fermer",
      "inputMappings": "Connexions",
      "noInputSlots": "Ce bloc ne prend aucune entrée.",
      "noIncomingEdges": "Aucune connexion vers ce bloc pour l'instant.",
      "editMapping": "Modifier le mappage",
      "emptyMapping": "Aucune entrée mappée pour l'instant.",
      "parameters": "Paramètres",
      "noEditableParams": "Cette fonction n'a aucun paramètre modifiable.",
      "functionNotInCatalog": "Cette fonction ne figure plus dans le catalogue de cet espace de travail.",
      "missingWidgetKind": "« {{name}} » ne peut pas être modifié ici. Contactez le support si vous devez le changer.",
      "pickColumn": "Choisissez une colonne produite par le bloc amont connecté.",
      "columnFreeText": "Saisissez un nom de colonne — connectez l'entrée pour choisir parmi les colonnes amont.",
      "enumFreeText": "Aucune option déclarée — saisissez une valeur.",
      "unset": "Non défini",
      "defaultPlaceholder": "Par défaut : {{value}}",
      "effectiveDefault": "Laissé vide — c'est la valeur par défaut du schéma, {{value}}, qui sera exécutée.",
      "deleteNode": "Supprimer le bloc",
      "editCustomCode": "Régénérer le code",
      "subKeyCompleteness": "{{filled}} sur {{total}} champs requis renseignés"
    },
    "mapping": {
      "title": "Mappage de la connexion",
      "unmapped": "Non mappé",
      "incompatible": "Types incompatibles — le validateur le signalera.",
      "save": "Enregistrer le mappage",
      "deleteEdge": "Supprimer la connexion",
      "producerUnknown": "Les sorties de ce bloc ne sont pas encore au catalogue ; ses membres ne peuvent pas être listés ici.",
      "consumerUnknown": "Les entrées de ce bloc ne sont pas encore déclarées ; ses arguments ne peuvent pas être listés ici.",
      "noArgs": "Ce bloc ne prend aucune entrée."
    },
    "validWithWarnings_one": "Valide — {{count}} à finaliser",
    "validWithWarnings_other": "Valide — {{count}} à finaliser",
    "configPending": "Configuration en attente",
    "configPendingBanner": "Structure enregistrée — la configuration est incomplète, ce pipeline ne peut pas encore s'exécuter.",
    "configPassRun": "Lancer la passe de configuration",
    "configPassStarted": "Lancée — suivez-la dans la discussion",
    "configPassRequest": "Lancer la passe de configuration sur le brouillon actuel."
  },
  "customNode": {
    "titleResolve": "Résoudre le nœud personnalisé",
    "subtitle": "Décrivez la logique et laissez l’assistant écrire le nœud, ou importez du code existant à adapter.",
    "turnActive": "L'assistant est occupé. Réessayez une fois la réponse en cours terminée.",
    "promptLabel": "Que doit faire ce nœud ?",
    "promptPlaceholder": "p. ex. Calculer l'indice de stabilité de population entre les distributions de scores de référence et actuelles.",
    "chooseFile": "Téléverser du code",
    "uploadAction": "Téléverser et normaliser",
    "generateAction": "Générer le code",
    "forNode": "pour le nœud {{id}}",
    "forNew": "comme nouvelle étape",
    "generateRequest": "Veuillez générer un nœud personnalisé {{target}} :",
    "uploadRequest": "Veuillez normaliser ce code téléversé en un nœud personnalisé {{target}} (fichier : {{name}}) :"
  },
  "run": {
    "heading": "Exécution",
    "runButton": "Exécuter le pipeline",
    "running": "Exécution…",
    "cancel": "Annuler l'exécution",
    "versionLabel": "Exécution v{{n}}",
    "pastRunView": "Consultation d'une exécution passée",
    "emptyHint": "Exécutez ce pipeline pour voir l'état d'exécution et les résultats ici.",
    "inFlight": "Exécution…",
    "blockProgress": "{{done}}/{{total}} étapes",
    "failedGeneric": "L'exécution a échoué. Vérifiez le pipeline et réessayez.",
    "cancelledHint": "Cette exécution a été annulée.",
    "resultsHeading": "Résultats",
    "sendToProject": "Envoyer vers un projet",
    "sendToProjectToolLabel": "Exécution du banc d'essai",
    "noPreview": "Aucun aperçu disponible pour cet artéfact.",
    "previewTruncated": "Affichage des {{shown}} premières lignes sur {{total}}.",
    "previewFirstRows": "Affichage des {{shown}} premières lignes.",
    "artifacts": "Artéfacts",
    "artifact": "Artéfact",
    "download": "Télécharger",
    "pastRuns": "Exécutions passées",
    "timelineHeading": "Étapes d'exécution",
    "noArtifacts": "Cette exécution n'a produit aucun artéfact.",
    "preview": "Aperçu",
    "hidePreview": "Masquer l'aperçu",
    "block": {
      "status": {
        "succeeded": "Réussie",
        "failed": "Échouée",
        "skipped": "Ignorée",
        "running": "En cours",
        "pending": "En attente",
        "unknown": "Inconnu"
      },
      "pendingSummary_one": "{{count}} étape restante en attente",
      "pendingSummary_other": "{{count}} étapes restantes en attente",
      "outputs": "Sorties",
      "noOutputs": "Cette étape n'a produit aucune sortie.",
      "skippedUpstream": "Une étape précédente a échoué, cette étape n'a donc pas été exécutée.",
      "skippedCancelled": "L'exécution a été annulée avant cette étape.",
      "error": {
        "generic": "Cette étape a échoué.",
        "validation_failed": "La configuration de cette étape n'a pas passé la validation.",
        "unknown_param": "Cette étape a reçu un paramètre non reconnu.",
        "unresolved_input_binding": "L'entrée de cette étape n'a pas pu être reliée à la sortie d'une étape précédente.",
        "input_load_failed": "Les données d'entrée de cette étape n'ont pas pu être chargées.",
        "bf_invocation_failed": "La fonction de cette étape a échoué pendant l'exécution.",
        "invalid_return": "La fonction de cette étape a renvoyé un résultat inattendu.",
        "artifact_write_failed": "La sortie de cette étape n'a pas pu être enregistrée.",
        "kernel_unreachable": "Le moteur d'exécution est injoignable.",
        "block_timeout": "Cette étape a pris trop de temps et a expiré.",
        "skipped_upstream_failed": "Une étape précédente a échoué, cette étape n'a donc pas été exécutée.",
        "cancelled": "L'exécution a été annulée avant la fin de cette étape.",
        "user_cancelled": "L'exécution a été annulée avant cette étape."
      }
    },
    "status": {
      "queued": "En attente",
      "executing": "En cours",
      "running": "En cours",
      "succeeded": "Réussie",
      "failed": "Échouée",
      "cancelled": "Annulée",
      "stale": "Arrêtée"
    },
    "error": {
      "validation_failed": "Ce pipeline n'a pas passé la validation. Corrigez les étapes signalées et relancez.",
      "bf_invocation_failed": "La fonction d'une étape a échoué pendant l'exécution. Vérifiez l'étape signalée et réessayez.",
      "input_load_failed": "Une étape n'a pas pu charger ses données d'entrée. Vérifiez vos données et réessayez.",
      "unresolved_input_binding": "L'entrée d'une étape n'est pas connectée à la sortie d'une étape précédente. Vérifiez les connexions et réessayez.",
      "block_timeout": "Une étape a pris trop de temps et a expiré. Veuillez réessayer.",
      "kernel_unreachable": "Le moteur d'exécution n'a pas pu être joint. Veuillez réessayer.",
      "invalid_return": "Une étape a renvoyé un résultat inattendu. Vérifiez le pipeline et réessayez.",
      "artifact_write_failed": "La sortie d'une étape n'a pas pu être enregistrée. Veuillez réessayer.",
      "unknown_param": "Une étape a reçu un paramètre qu'elle ne reconnaît pas. Vérifiez la configuration de l'étape et réessayez.",
      "node_timeout": "Une étape a dépassé le temps qui lui était imparti et a été arrêtée. Relancez l'exécution pour reprendre à cette étape — les étapes précédentes conservent leurs résultats.",
      "kernel_unresponsive": "Le moteur d'exécution a cessé de répondre pendant une étape. Relancez l'exécution pour reprendre à cette étape — les étapes précédentes conservent leurs résultats.",
      "watchdog_stranded": "L'exécution a cessé de répondre et n'a pas pu être reprise. Veuillez la relancer."
    }
  },
  "data": {
    "dropzoneTitle": "Ajoutez vos données",
    "dropzoneSubtitle": "Glissez-déposez, ou choisissez des fichiers .parquet, .csv ou .xlsx.",
    "chooseFiles": "Choisir des fichiers",
    "addData": "Ajouter des données",
    "catalogHeading": "{{confirmed}}/{{total}} confirmées",
    "pollingAria": "Traitement des tables",
    "singleTable": "Table",
    "selectTable": "Sélectionnez une table pour afficher ses détails.",
    "uploadQueued": "Téléversement reçu — préparation de vos données.",
    "rowColCount": "{{rows}} lignes · {{cols}} colonnes",
    "reEnrich": "Ré-analyser",
    "confirm": "Confirmer",
    "attentionTitle": "Cette table requiert votre attention",
    "attentionGeneric": "Un problème est survenu lors de la préparation de cette table. Essayez de la ré-analyser.",
    "processingHint": "Préparation de cette table…",
    "confirmedHint": "Cette table est confirmée et prête à être utilisée dans un cas de test.",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Que représente cette table ?",
    "schemaTab": "Schéma",
    "sampleTab": "Échantillon",
    "colName": "Colonne",
    "colType": "Type",
    "colRole": "Rôle",
    "colMeaning": "Signification",
    "roleUnset": "Non défini",
    "noColumns": "Aucune colonne détectée.",
    "notDescribed": "Non décrite",
    "saveOverrides": "Enregistrer les modifications",
    "noSample": "Aucune ligne d'échantillon disponible."
  },
  "role": {
    "identifier": "Identifiant",
    "time_index": "Index temporel",
    "target": "Cible",
    "feature": "Caractéristique",
    "reference": "Référence",
    "other": "Autre"
  },
  "status": {
    "queuedEnumerate": "En attente",
    "enumerating": "Lecture du fichier",
    "queuedParse": "En attente",
    "parsing": "Conversion",
    "queuedEnrich": "En attente",
    "enriching": "Analyse",
    "ready": "Prête",
    "attention": "Attention requise",
    "confirmed": "Confirmée",
    "cancelled": "Annulée",
    "deleted": "Supprimée",
    "unknown": "Inconnu"
  },
  "validation": {
    "generic": "Cette étape a un problème de configuration.",
    "input_table_unbound": "Cette entrée n'est pas encore liée à une table confirmée.",
    "custom_node_unresolved": "Ce nœud personnalisé a encore besoin de son code.",
    "custom_io_undeclared": "Ce nœud personnalisé n'a pas déclaré ses entrées et sorties.",
    "slot_name_invalid": "Le nom d'une entrée ou d'une sortie de ce nœud personnalisé ne peut pas être utilisé. Choisissez un nom sans barre oblique et qui ne soit pas composé uniquement de points.",
    "unmapped_required_arg": "Une entrée requise n'est pas connectée.",
    "unknown_output_member": "Une connexion référence une sortie que cette étape ne produit pas.",
    "unknown_input_arg": "Une connexion cible une entrée que cette étape ne possède pas.",
    "duplicate_arg_binding": "Une entrée est connectée plus d'une fois.",
    "duplicate_edge": "Deux étapes sont connectées plusieurs fois — regroupez la connexion.",
    "forward_anchor_invalid": "Cette étape personnalisée ne déclare pas clairement l'entrée qu'elle transmet.",
    "custom_contract_missing": "Les entrées et sorties de cette étape personnalisée n'ont pas pu être vérifiées.",
    "custom_contract_divergent": "Les entrées et sorties de cette étape personnalisée ont changé après la génération de son code.",
    "missing_input_node": "Cette étape nécessite une entrée qui n'est pas connectée.",
    "cycle_detected": "Le pipeline contient une boucle entre des étapes.",
    "disconnected_node": "Cette étape n'est pas reliée au pipeline.",
    "content_type_mismatch": "Une connexion relie des types de données incompatibles.",
    "column_unsatisfied": "Une colonne requise n'est pas disponible à cette étape.",
    "params_unfilled": "Les paramètres de cette étape n'ont pas encore été configurés.",
    "missing_required_param": "Un paramètre requis n'est pas défini.",
    "incomplete_object_param": "Un paramètre groupé n'a pas tous ses champs requis.",
    "null_param_value": "Un paramètre est défini sans valeur, alors que cette étape en exige une.",
    "param_type_mismatch": "Un paramètre a un type de valeur incorrect pour cette étape.",
    "unknown_param_key": "Un paramètre groupé contient un champ que cette étape n'utilise pas.",
    "invalid_node": "Cette étape ne comporte pas les informations nécessaires pour l'identifier.",
    "duplicate_node_id": "Deux étapes partagent le même identifiant — chacune doit avoir le sien.",
    "unresolved_shared_variable": "Cette étape fait référence à une valeur partagée qui n'a pas été définie.",
    "unknown_node_ref": "Ceci fait référence à une étape qui n'existe plus.",
    "invalid_edge_target": "Une connexion pointe vers quelque chose qui n'est pas une étape valide.",
    "forward_from_source_file_invalid_chain": "Cette étape transmet des données provenant d'une entrée, mais l'application ne peut pas retracer ce chemin jusqu'à une entrée.",
    "unused_input_node": "Cette entrée n'est utilisée nulle part dans le pipeline.",
    "missing_required_key": "Le fichier du pipeline ne contient pas certaines informations nécessaires.",
    "yaml_syntax_error": "Le fichier du pipeline n'a pas pu être lu.",
    "top_level_not_mapping": "Le fichier du pipeline n'est pas structuré comme l'application l'attend.",
    "schema_version_invalid": "La version du fichier du pipeline n'est pas reconnue.",
    "schema_version_unsupported": "Ce fichier de pipeline a été créé pour une version que cette application ne prend pas en charge.",
    "block_not_mapping": "L'une des étapes du fichier du pipeline n'est pas structurée correctement.",
    "input_bindings_unsupported": "Ce fichier de pipeline utilise un format d'entrée qui n'est plus pris en charge.",
    "unknown_block_kind": "L'une des étapes du fichier du pipeline n'est pas d'un type reconnu par l'application.",
    "unknown_tool_slug": "L'une des étapes fait référence à un outil qui n'existe pas.",
    "edge_not_mapping": "L'une des connexions du fichier du pipeline n'est pas structurée correctement.",
    "edge_unknown_key": "L'une des connexions contient des informations que l'application ne reconnaît pas.",
    "edge_mapping_missing": "Il manque des informations nécessaires à l'une des connexions.",
    "edge_mapping_invalid": "L'une des connexions n'est pas configurée correctement.",
    "edge_endpoint_missing": "Il manque une extrémité à l'une des connexions.",
    "edge_endpoint_not_scalar": "L'une des connexions pointe vers plusieurs éléments à la fois.",
    "params_by_block_invalid": "Les paramètres de l'une des étapes ne sont pas correctement formatés.",
    "patch_empty_yaml": "Le fichier du pipeline est vide.",
    "patch_root_not_mapping": "Le fichier du pipeline n'est pas structuré comme l'application l'attend.",
    "patch_no_blocks": "Le fichier du pipeline ne contient aucune étape.",
    "patch_no_input_block": "Le fichier du pipeline n'a pas d'étape d'entrée à mettre à jour.",
    "execution_not_mapping": "Les paramètres d'exécution du pipeline ne sont pas dans la forme attendue.",
    "execution_unknown_key": "Les paramètres d'exécution du pipeline contiennent un paramètre non reconnu.",
    "execution_node_timeout_invalid": "La limite de temps par étape doit être un nombre entier de secondes supérieur à zéro.",
    "execution_node_timeout_above_ceiling": "La limite de temps par étape ne peut pas dépasser 72 heures."
  },
  "errorStage": {
    "sheet_enumeration_failed": "Impossible de lire les feuilles de ce fichier.",
    "materialize_failed": "Impossible de convertir cette table.",
    "peek_failed": "Impossible de lire cette table.",
    "csv_row_wider_than_header": "Une ligne contient plus de valeurs que l'en-tête. Vérifiez que chaque ligne a le même nombre de colonnes que l'en-tête, puis importez à nouveau le fichier.",
    "table_exceeds_memory_budget": "Cette table est trop volumineuse pour être traitée. Divisez-la en fichiers plus petits, avec moins de lignes ou de colonnes, puis importez-les à nouveau.",
    "enrichment_llm_failed": "Impossible d'analyser cette table.",
    "schema_mismatch": "Les colonnes de la table ne correspondent pas à ce qui était attendu.",
    "stalled": "La préparation de cette table s'est interrompue de façon inattendue."
  },
  "error": {
    "generic": "Une erreur est survenue. Veuillez réessayer.",
    "stageFailed": "Le chargement de cette étape a échoué.",
    "network_error": "Impossible de joindre le serveur. Vérifiez votre connexion et réessayez.",
    "request_timeout": "La requête a pris trop de temps. Veuillez réessayer.",
    "stale_row_version": "Cet élément a changé pendant votre modification. Nous l'avons actualisé — veuillez vérifier et réessayer.",
    "invalid_user_overrides": "Vos modifications n'ont pas pu être enregistrées, car leur format n'est pas celui attendu. Actualisez la page et réessayez.",
    "dataset_not_ready": "Cette table n'est pas encore prête à être confirmée.",
    "enrich_in_progress": "Cette table est déjà en cours d'analyse.",
    "dataset_already_uploaded": "Ce fichier a déjà été téléversé.",
    "upload_finalize_in_progress": "Ce fichier est encore en cours d'enregistrement. Patientez un instant, puis actualisez pour vérifier qu'il a été ajouté.",
    "upload_blob_properties_not_allowed": "Ce fichier a été téléversé avec des paramètres de stockage que nous ne pouvons pas accepter. Téléversez-le de nouveau depuis cette page.",
    "unsupported_source_format": "Ce type de fichier n'est pas pris en charge. Importez un fichier .parquet, .csv ou .xlsx.",
    "upload_failed": "Le téléversement n'a pas abouti. Veuillez réessayer.",
    "upload_too_large": "« {{filename}} » dépasse la limite de {{limit_mb}} Mo par fichier.",
    "upload_size_mismatch": "La taille du fichier importé ne correspondait pas à celle attendue ; il n'a pas été accepté. Veuillez réessayer de l'importer.",
    "empty_file": "Le fichier « {{filename}} » est vide.",
    "workspace_not_found": "Cet espace est introuvable.",
    "dataset_not_found": "Cette table est introuvable.",
    "case_not_found": "Ce cas de test est introuvable.",
    "version_not_found": "Cette exécution est introuvable.",
    "create_failed": "Impossible de créer cet élément. Veuillez réessayer.",
    "delete_failed": "Impossible de supprimer cet élément. Veuillez réessayer.",
    "save_failed": "Impossible d'enregistrer vos modifications. Veuillez réessayer.",
    "confirm_failed": "Impossible de confirmer cette table. Veuillez réessayer.",
    "reenrich_failed": "Impossible de ré-analyser cette table. Veuillez réessayer.",
    "sample_failed": "Impossible de charger les lignes d'échantillon.",
    "sample_read_failed": "Impossible de prévisualiser ce résultat. Veuillez réessayer.",
    "sample_shape_invalid": "Impossible de prévisualiser ce résultat. Veuillez réessayer.",
    "catalog_load_failed": "Impossible de charger votre catalogue de données.",
    "workspace_load_failed": "Impossible de charger cet espace.",
    "workspaces_load_failed": "Impossible de charger vos espaces.",
    "capabilities_unavailable": "Le banc d'essai est temporairement indisponible.",
    "turns_load_failed": "Impossible de charger cette conversation.",
    "turn_send_failed": "Votre message n'a pas pu être envoyé. Veuillez réessayer.",
    "turn_cancel_failed": "Impossible d'arrêter la réponse en cours.",
    "turn_in_progress": "L'assistant répond encore. Veuillez patienter un instant.",
    "turn_not_cancellable": "Cette réponse est déjà terminée.",
    "attach_too_large": "Ce fichier dépasse la limite de 5 Mo.",
    "attach_extract_failed": "Impossible de lire ce fichier — il est peut-être endommagé, ou son contenu n'a pas pu être extrait.",
    "attach_unreadable_format": "Ce fichier ne contient pas de texte lisible.",
    "attach_extract_unavailable": "Le lecteur de documents est temporairement indisponible — veuillez réessayer dans un instant.",
    "invalid_request": "Ce fichier n'a pas pu être joint. Veuillez réessayer.",
    "runs_load_failed": "Impossible de charger vos exécutions.",
    "run_start_failed": "Impossible de démarrer l'exécution. Veuillez réessayer.",
    "run_cancel_failed": "Impossible d'annuler l'exécution.",
    "run_in_progress": "Une exécution est déjà en cours pour ce cas de test.",
    "version_cap_exceeded": "Ce cas de test a atteint sa limite d'exécutions. Créez un nouveau cas de test pour continuer.",
    "version_already_terminal": "Cette exécution est déjà terminée.",
    "pipeline_empty": "Il n'y a pas encore de pipeline à exécuter. Concevez-en un dans le chat Découverte.",
    "pipeline_invalid": "Le pipeline comporte des problèmes non résolus. Corrigez-les avant l'exécution.",
    "pipeline_config_yaml_invalid": "Le pipeline n'a pas pu être lu. Veuillez le vérifier dans Conception.",
    "pipeline_load_failed": "Impossible de charger votre pipeline.",
    "pipeline_parse_failed": "Impossible de lire ce pipeline.",
    "issue_centre_failed": "Impossible de déplacer le canevas jusqu'à cet élément.",
    "issue_target_gone": "Cet élément ne figure plus sur le canevas.",
    "structural_pending": "Enregistrement de votre modification. Attendez la fin avant d'en faire une autre.",
    "structural_save_unconfirmed": "Enregistrement de votre modification en cours. Il n'est pas encore confirmé : attendez la fin.",
    "draft_locked": "L'assistant met à jour ce pipeline. Réessayez une fois qu'il a terminé.",
    "functions_load_failed": "Impossible de charger la palette de fonctions.",
    "invalid_scope_path": "Ce secteur n'est pas dans le menu des services. Choisissez un secteur du menu.",
    "pipeline_yaml_unparseable": "Cette modification ne peut pas être lue comme un pipeline ; elle n'a pas été enregistrée. Annulez la modification ou corrigez la structure.",
    "scope_vocabulary_unavailable": "Le menu des services nécessaire à la validation du secteur est temporairement indisponible. Réessayez sous peu.",
    "reggie_write_forbidden": "Vous ne pouvez pas modifier cet espace de test. Demandez au propriétaire du modèle ou à un administrateur de vous accorder l’autorisation Collaborateur dans l’onglet Accès du modèle.",
    "reggie_sso_required": "Connectez-vous avec votre compte d'organisation pour utiliser le banc d'essai.",
    "reggie_upstream_unreachable": "Le banc d'essai est temporairement injoignable. Veuillez réessayer dans un instant.",
    "webhook_url_invalid": "L'URL du webhook doit être une adresse https:// absolue et accessible depuis Internet.",
    "webhook_url_unverified": "Impossible de vérifier cette adresse de webhook pour le moment. Réessayez d'enregistrer dans un instant.",
    "input_source_not_owned": "Le fichier d'entrée de ce pipeline n'est pas accessible depuis votre compte. Joignez à nouveau les données source, puis lancez l'exécution.",
    "speech_disabled": "La saisie vocale est indisponible.",
    "speech_rate_limited": "Trop de messages vocaux. Patientez un instant et réessayez.",
    "speech_audio_invalid": "L’enregistrement n’a pas pu être lu. Enregistrez à nouveau votre message.",
    "speech_no_speech": "Aucune parole n’a été entendue. Réessayez.",
    "speech_upstream_failed": "Votre message vocal n’a pas pu être transcrit. Réessayez.",
    "speech_upstream_timeout": "La transcription a pris trop de temps. Réessayez.",
    "speech_unsupported": "Ce navigateur ne prend pas en charge la saisie vocale.",
    "speech_mic_denied": "L’accès au microphone a été refusé. Autorisez-le dans les paramètres du navigateur et réessayez.",
    "speech_mic_unavailable": "Aucun microphone n’a été trouvé. Branchez-en un et réessayez.",
    "speech_mic_busy": "Le microphone n’a pas pu être ouvert. Vérifiez si une autre application l’utilise.",
    "speech_cancelled": "Saisie vocale annulée.",
    "speech_composer_disabled": "La saisie vocale a été arrêtée car le chat est occupé. Votre brouillon est inchangé.",
    "speech_request_timeout": "La transcription a pris trop de temps. Réessayez.",
    "speech_request_failed": "La saisie vocale a échoué. Réessayez.",
    "speech_send_failed": "Votre message vocal n’a pas pu être envoyé. Réessayez.",
    "request_body_too_large": "Cette demande est trop volumineuse."
  }
}
